// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t88b","select":"styles_select__1bn4R"};